import MockAdapter from 'axios-mock-adapter/types';
import area from './area';
import diretoria from './diretoria';
import contrato from './contrato/contratoBase';
import aditivosContrato from './contrato/aditivosContrato';
import usuario from './usuario';
import tipoUsuario from './tipoUsuario';
import tipoServico from './tipoServico';
import seguroGarantia from './contrato/seguroGarantiasContrato';
import resumoMedicoes from './contrato/resumoMedicoesContrato';
import correspondencias from './contrato/correspondencia';
import caixaEntrada, { processo } from './acs/caixaEntrada';
import contabilidadeGeral, { processo } from './cont/contabilidadeGeral';
import dashboardContrato from './dashboard/dashboardContratos';
import graficoTipoServicos from './dashboard/graficoTipoServicos';
import dashboardContratosTop from './dashboard/dashboardContratosTop';
import dashboardMedicao from './dashboard/dashboardMedicao';
import dashboardStatusAP from './dashboard/dashboardStatusAP';
import dashboardStatusAM from './dashboard/dashboardStatusAM';
import relatorioPrevisaoPgto from './relatorio/relatorioPrevisoesPagamento';
import relatorioEncerramentoContratos from './relatorio/relatorioEncerramentoContratos';
import relatorioSegurosGarantias from './relatorio/relatorioSegurosGarantias';
import relatorioStatusMedicoes from './relatorio/relatorioStatusMedicoes';
import relatorioStatusCorrespondencias from './relatorio/relatorioStatusCorrespondencias';
import relatorioControleQaQc from './relatorio/relatorioControleQaQc';
import matching from './matching';
import { medicoes, itensMedicoes, medicao, anexoMedicao } from './boletimMedicao';

export default (mock: MockAdapter) => {
  mock.onGet('areas').reply(200, area);
  mock.onGet('diretorias').reply(200, diretoria);
  mock.onGet('contratos').reply(200, contrato);
  mock.onGet('aditivos').reply(200, aditivosContrato);
  mock.onGet('usuarios').reply(200, usuario);
  mock.onGet('tipoUsuarios').reply(200, tipoUsuario);
  mock.onGet('tiposServico').reply(200, tipoServico);
  mock.onGet('segurosGarantias').reply(200, seguroGarantia);
  mock.onGet('resumosMedicoes').reply(200, resumoMedicoes);
  mock.onGet('correspondencias').reply(200, correspondencias);
  mock.onGet('caixaEntrada').reply(200, caixaEntrada);
  mock.onGet('contabilidadeGeral').reply(200, contabilidadeGeral);
  mock.onGet('getProcesso').reply(200, processo);
  mock.onGet(`usuarios/564652131dgdfgd`).reply(200, usuario[0]);
  mock.onGet('contratosPorTipoServicos').reply(200, dashboardContrato);
  mock.onGet('graficoTipoServicos').reply(200, graficoTipoServicos);
  mock.onGet('contratosTop').reply(200, dashboardContratosTop);
  mock.onGet('dashboardMedicao').reply(200, dashboardMedicao);
  mock.onGet('dashboardStatusAP').reply(200, dashboardStatusAP);
  mock.onGet('dashboardStatusAM').reply(200, dashboardStatusAM);
  mock.onPost('relatorio/previsaoPgto').reply(200, relatorioPrevisaoPgto);
  mock.onPost('relatorio/encerramentoContratos').reply(200, relatorioEncerramentoContratos);
  mock.onPost('relatorio/segurosGarantias').reply(200, relatorioSegurosGarantias);
  mock.onPost('relatorio/statusMedicoes').reply(200, relatorioStatusMedicoes);
  mock.onPost('relatorio/statusCorrespondencias').reply(200, relatorioStatusCorrespondencias);
  mock.onPost('relatorio/relatorioControleQaQc').reply(200, relatorioControleQaQc);
  mock.onPost('matching').reply(200, matching);
  mock.onGet('Medicao').reply(200, medicoes);
  mock.onGet('Medicao/ObterItensMedicoesPorMedicaoId/ecb7253e-6eb4-4371-8bda-9073b5c9eb60').reply(200, itensMedicoes);
  mock.onGet('Medicao/ObterMedicaoEdit/ecb7253e-6eb4-4371-8bda-9073b5c9eb60').reply(200, medicao);
  mock.onGet('Medicao/GetAllAnexoMedicaoEditMedicao/ecb7253e-6eb4-4371-8bda-9073b5c9eb60').reply(200, anexoMedicao);
};
